import React from "react";

const AussieRules = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      className={className}
    >
      <g clip-path="url(#clip0_14545_80013)">
        <path d="M17.25 0.75C17.8781 0.75 18.4875 0.848437 19.0547 1.02656C18.0656 1.11094 16.9688 1.43438 15.8203 1.94063C13.3172 3.04219 10.4391 5.07656 7.75312 7.75781C5.06719 10.4391 3.04219 13.3172 1.94063 15.825C1.43438 16.9734 1.11094 18.0703 1.02656 19.0594C0.848437 18.4875 0.75 17.8781 0.75 17.25V15.75C0.75 7.46719 7.46719 0.75 15.75 0.75H17.25ZM22.9734 4.94531C23.1516 5.51719 23.25 6.12187 23.25 6.75V8.25C23.25 16.5328 16.5328 23.25 8.25 23.25H6.75C6.12187 23.25 5.5125 23.1516 4.94531 22.9734C5.93437 22.8891 7.03125 22.5656 8.17969 22.0594C10.6828 20.9578 13.5609 18.9234 16.2469 16.2422C18.9328 13.5609 20.9625 10.6828 22.0641 8.175C22.5703 7.02656 22.8938 5.92969 22.9781 4.94063L22.9734 4.94531ZM2.98594 21.0141C2.67188 20.7 2.475 20.1797 2.50781 19.3828C2.54062 18.5812 2.80312 17.5781 3.30937 16.4297C4.31719 14.1328 6.22969 11.4094 8.81719 8.82187C11.4047 6.23438 14.1328 4.32656 16.425 3.31406C17.5734 2.80781 18.5766 2.54531 19.3781 2.5125C20.1797 2.47969 20.6953 2.67656 21.0094 2.99062C21.3234 3.30469 21.5203 3.825 21.4875 4.62187C21.4547 5.42344 21.1922 6.42656 20.6859 7.575C19.6781 9.87188 17.7656 12.5953 15.1781 15.1828C12.5906 17.7703 9.8625 19.6781 7.57031 20.6906C6.42188 21.1969 5.41875 21.4594 4.61719 21.4922C3.81562 21.525 3.3 21.3328 2.98594 21.0141Z" />
      </g>
    </svg>
  );
};

export default AussieRules;
